import { connect } from 'react-redux';

import ResetView from '../components/Steps/Reset/ResetView';

import { clearInputError, setInputError } from '../actions/GenericActions';
import {
  initPasswordValidator, resetPassword, setCnilError, updateCnil,
} from '../actions/ResetActions';

const mapDispatchToProps = dispatch => ({
  initPasswordValidator: () => dispatch(initPasswordValidator()),
  updateCnil: password => dispatch(updateCnil(password)),
  clearInputError: ({ field }) => dispatch(clearInputError({ field })),
  setInputError: ({ field, error }) => dispatch(setInputError({ field, error })),
  setCnilError: error => dispatch(setCnilError(error)),
  resetPassword: ({
    password,
    passAgain,
  }) => dispatch(resetPassword({ password, passAgain })),
});

const mapStateToProps = state => ({
  cnilRules: state.reset.cnilRules,
  cnilError: state.reset.cnilError,
  isSaving: state.reset.isSaving,
  isLoading: state.generic.request.isLoading,
  form: state.reset.form,
  login: state.choice.identities.login,
  passwordError: state.reset.passwordError,
  passAgainError: state.reset.passAgainError,
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetView);
